import angular from 'angular';

function Authentication($rootScope, $state, authService) {
  $rootScope.$on('$stateChangeStart', (event, toState, toParams) => {
    _handleAuthentication(event, toState, toParams);
  });

  function _handleAuthentication(event, toState, toParams) {
    if (toState.authenticate === true && !authService.isLoggedIn()) {
      event.preventDefault(); // prevent the state change

      const params = {
        redirectState: toState.name,
        redirectParams: angular.toJson(toParams)
      };

      $state.go('app.login', params);
    }
  }
}

Authentication.$inject = [
  '$rootScope',
  '$state',
  'jsSdk.auth'
];

export default Authentication;



// WEBPACK FOOTER //
// ./src/authentication.js